import { upload } from "@/api";

export interface UploadImagesResponse {
  errno?: number | string;
  error?: boolean | number;
  message?: string;
  msg?: string;
  data?: string[];
}

/** 批量上传图片到七牛，返回 CDN URL 列表 */
export function uploadImages(files: File[]) {
  const formData = new FormData();
  files.forEach((file, index) => {
    formData.append(`file${index}`, file);
  });
  return upload<UploadImagesResponse>("/platform/upload/images", formData);
}
